import { getInstance } from './index';
import jwt_decode from "jwt-decode";


export const authGuard = (to, from, next) => {
  const authService = getInstance();

  async function get_permissions_func_v2() {
    let token = await authService.getTokenSilently()
    console.log(token)
    var decoded = jwt_decode(token);
    console.log(decoded)

    return decoded.permissions;
  }


  function get_permissions_func() {
    let userauth = authService.user['https://app.oceanbolt.com/user_authorization'] || {};
    return userauth.permissions;
  }


  const fn = () => {
    
    // must be called when authService.loading === false
    // otherwise permissions will be unreachable and page won't be loaded
    // even if all is ok with a user, it happens when for example the "/drydock" page is reloaded with F5

    if (!authService.isAuthenticated) {
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });

      // loginWithRedirect doesn't interrupt this method, so we need to return from it explicitely
      return next(false);
    }

    let permissions = get_permissions_func();

    if (!permissions.includes('user:admin')) {
      authService.logout();
    }

    // allow to navigate to a required url (user is authenticated here)
    return next();
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
